import React from 'react';
import { styled } from 'linaria/react';
import UIMaxWidth from '../Layout/MaxWidth';
import { LoadingLine } from '@jetshop/ui/Loading/LoadingLine';
import { theme } from '../Theme';
import Stores from '../Stores/Stores';

const Content = styled('div')`
  border-top: 1px solid #eaeaea;
  color: black;

  font-size: 16px;
  font-weight: 300;
  line-height: 1.4;
  padding-top: 2rem;
  padding-bottom: 1rem;
  ${theme.below.lg} {
    margin-top: 2rem;
    padding: 2.5rem 1rem 0rem 1rem;
  }
  ${theme.below.md} {
    margin-top: 1.5rem;
    padding: 2rem 1rem 0rem 1rem;
  }
  ${theme.below.sm} {
    padding: 2rem 0.5rem;
  }
  ${theme.below.xs} {
    margin-top: 0.75rem;
    padding-top: 1rem;
  }

  strong {
    color: black;
    font-weight: 400;
  }

  .Body strong {
    font-weight: bold;
    text-transform: uppercase;
  }

  h1 {
    color: black;

    font-size: 1.5rem;
    font-weight: 300;
  }

  h2 {
    font-size: 1.5rem;
    font-weight: 300;
    margin-bottom: 1rem;
  }

  img {
    max-width: 100%;
  }

  iframe {
    margin: 1rem 0;
  }

  p {
    color: black;

    font-size: 14px;
    font-weight: 300;
    line-height: 1.4rem;
    margin: auto;
    margin-bottom: 1em;
    width: 100%;
    a {
      color: #d3d3d3;
      text-decoration: none;
      transition: all 0.3s;
      :hover {
        color: black;
      }
    }
    strong {
      font-weight: bold;
    }
  }
`;

const MaxWidth = styled(UIMaxWidth)`
  max-width: 72.5rem;
  padding: 0;
`;

function ContentPage(props) {
  const { result, page } = props;

  if (!page) {
    return <LoadingLine heightPx={27} widthRem={15} />;
  }

  return (
    <>
      <MaxWidth>
        {page ? (
          <>
            <Content
              dangerouslySetInnerHTML={{
                __html: result.data.route.object.content
              }}
            />

            {result.data.route.path === '/butiker' && (
              <>
                <Stores />
              </>
            )}
          </>
        ) : (
          <LoadingLine
            heightPx={14}
            widthRem={30}
            randomizeWidthBy={10}
            count={10}
            style={{
              marginBottom: '12px'
            }}
          />
        )}
      </MaxWidth>
    </>
  );
}

export default ContentPage;
